import { render, staticRenderFns } from "./FormsZavislostiPo.vue?vue&type=template&id=3505d7be&"
import script from "./FormsZavislostiPo.vue?vue&type=script&lang=js&"
export * from "./FormsZavislostiPo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports